export default __webpack_public_path__ + "static/feature-event-autocapture-4b80632b2dd6b04b5fc77203bcf5aca6.svg";